import React from "react";
var __jsx = React.createElement;
import { Experience } from "@ninetailed/experience.js-next";
import componentsMap from "./components";
import ComponentRenderer from "./ComponentRenderer";
import { filterAndMapExperiences } from '../../../utils';
function BladeRenderer(_ref) {
  var _entry$ntExperiencesC, _entry$sys, _entry$sys2;
  var entry = _ref.entry,
    index = _ref.index,
    DynamicLayoutPage = _ref.DynamicLayoutPage,
    extensiveComponents = _ref.extensiveComponents,
    scrollbarWidth = _ref.scrollbarWidth,
    siteData = _ref.siteData,
    yextContactInformationData = _ref.yextContactInformationData,
    reviewData = _ref.reviewData,
    path = _ref.path,
    pagePath = _ref.pagePath;
  var component = componentsMap === null || componentsMap === void 0 ? void 0 : componentsMap[entry === null || entry === void 0 ? void 0 : entry.__typename];
  if (!component) {
    return null;
  }
  var data = {
    scrollbarWidth: scrollbarWidth,
    DynamicLayoutPage: DynamicLayoutPage,
    shouldPreloadImage: index === 0 && !(extensiveComponents !== null && extensiveComponents !== void 0 && extensiveComponents.hero),
    siteData: siteData,
    yextContactInformationData: yextContactInformationData,
    reviewData: reviewData,
    path: path,
    pagePath: pagePath
  };
  var mappedExperiences = entry !== null && entry !== void 0 && (_entry$ntExperiencesC = entry.ntExperiencesCollection) !== null && _entry$ntExperiencesC !== void 0 && _entry$ntExperiencesC.items.length ? filterAndMapExperiences({
    experiences: entry.ntExperiencesCollection.items,
    data: data
  }) : [];
  return __jsx(Experience, {
    key: index + (entry === null || entry === void 0 ? void 0 : (_entry$sys = entry.sys) === null || _entry$sys === void 0 ? void 0 : _entry$sys.id),
    id: entry === null || entry === void 0 ? void 0 : (_entry$sys2 = entry.sys) === null || _entry$sys2 === void 0 ? void 0 : _entry$sys2.id,
    component: ComponentRenderer,
    experiences: mappedExperiences,
    data: data,
    entry: entry
  });
}
;
export default BladeRenderer;